// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__2sn6y","HeaderContainer":"Header_HeaderContainer__163sn"};